import { useEffect, useState, useRef } from "react";
import { Card } from "../../../components/Shared/Card";
import { Content } from "../../../components/ui/ContentArea";
import { DateRangePicker } from "../../../components/ui/datepicker";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/hooks/useAuth";
import { GrafanaPanel } from "@/components/Dashboad/GrafanaPanel";
import GrafanaConfig from "@/components/Dashboad/Config/GrafanaConfig";
import { useDimensions } from "@/hooks/useDimensions";
export function DashboardPage() {
	const [selectedRange, setSelectedRange] = useState<{
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	}>({
		from: Temporal.Now.plainDateISO().subtract({ years: 1 }),
		to: Temporal.Now.plainDateISO(),
	});

	const [isLoggedIn, setIsLoggedIn] = useState(false);

	const [dinamicDashboard, setDinamicDashBoard] = useState<Panel>(1);

	const api = useApi();
	const auth = useAuth();
	const queryToken = api.useQuery(
		"get",
		"/v1/Empresa/Dashboard/TokenGrafana",
		{},
	);

	const section1Ref = useRef<HTMLDivElement>(null);
	const section2Ref = useRef<HTMLDivElement>(null);
	const section3Ref = useRef<HTMLDivElement>(null);

	const section1Size = useDimensions(section1Ref);
	const section2Size = useDimensions(section2Ref);
	const section3Size = useDimensions(section3Ref);

	useEffect(() => {
		if (queryToken.data) {
			console.log(queryToken.data.token);
			setIsLoggedIn(true);
		}
		console.log(dinamicDashboard);
	}, [dinamicDashboard, queryToken.data]);

	// Al entrar en la página se inicia sesión con un token muy corto
	// useEffect(() => {
	// 	if (queryToken.data) {
	// 		const loginUrl = `https://aeiriojabi.iker.wunder.intranet/login/jwt?token=${queryToken.data.token}`;
	// 		// Creamos un iframe invisible para hacer el login automático
	// 		const iframe = document.createElement("iframe");
	// 		iframe.src = loginUrl;
	// 		iframe.style.display = "none";
	// 		iframe.onload = () => {
	// 			setIsLoggedIn(true);
	// 			iframe.remove();
	// 		};
	// 		document.body.appendChild(iframe);
	// 	}
	// }, [queryToken.data !== undefined]);

	const changeDinamicDashboard = (value: string) => {
		value = value as "Mensual" | "Diario" | "Anual";
		switch (value) {
			case "Mensual":
				setDinamicDashBoard({
					idPanelDashboard: 1,
					idPanelTable: 4,
				});
				break;
			case "Diario":
				setDinamicDashBoard({
					idPanelDashboard: 3,
					idPanelTable: 5,
				});
				break;
			case "Anual":
				setDinamicDashBoard({
					idPanelDashboard: 2,
					idPanelTable: 6,
				});
				break;
			default:
				return 1;
		}
	};

	return (
		<Content className="p-5">
			<Card>
				<div
					className="dashboardNav"
					style={{ display: "flex", justifyContent: "left", gap: "5px" }}
				>
					<img src="/img/Logo_Cluster.svg" />
					<DateRangePicker
						value={selectedRange}
						onChange={setSelectedRange}
						literal="Periodo"
					/>
					<select
						className="dashBoardSelector"
						onChange={(e) => {
							changeDinamicDashboard(e.target.value);
						}}
					>
						<option>Diario</option>
						<option selected>Mensual</option>
						<option>Anual</option>
					</select>
				</div>
			</Card>
			<br />

			<br />
			{!isLoggedIn ? (
				<div>Cargando...</div>
			) : (
				<>
					<div
						ref={section1Ref}
						className="w-full"
						style={{ display: "flex", flexDirection: "column" }}
					>
						{GrafanaConfig.map((grafanaConf) => {
							if (grafanaConf.pageSection == 1)
								return (
									<GrafanaPanel
										{...grafanaConf}
										width={section1Size.width}
										companyId={
											auth.user?.userId &&
											import.meta.env.VITE_BI_MODE != "debug"
												? auth.user?.userId
												: 2
										}
										selectedRange={selectedRange}
										queryToken={queryToken.data.token ?? ""}
									/>
								);
						})}
					</div>
					<div style={{ display: "flex" }}>
						<div
							ref={section2Ref}
							className="w-full"
							style={{ display: "flex", flexDirection: "column" }}
						>
							{GrafanaConfig.map((grafanaConf) => {
								if (grafanaConf.pageSection == 2)
									return (
										<GrafanaPanel
											{...grafanaConf}
											width={section2Size.width}
											companyId={
												auth.user?.userId &&
												import.meta.env.VITE_BI_MODE != "debug"
													? auth.user?.userId
													: 2
											}
											selectedRange={selectedRange}
											queryToken={queryToken.data.token ?? ""}
										/>
									);
							})}
						</div>
						<div
							ref={section3Ref}
							className="w-full"
							style={{ display: "flex", flexDirection: "column" }}
						>
							{GrafanaConfig.map((grafanaConf) => {
								if (grafanaConf.pageSection == 3)
									return (
										<GrafanaPanel
											{...grafanaConf}
											width={section3Size.width}
											companyId={
												auth.user?.userId &&
												import.meta.env.VITE_BI_MODE != "debug"
													? auth.user?.userId
													: 2
											}
											selectedRange={selectedRange}
											queryToken={queryToken.data.token ?? ""}
										/>
									);
							})}
						</div>
					</div>
				</>
			)}
		</Content>
	);
}
interface DinamicDashboard {
	idPanelDashboard: number;
	idPanelTable: number;
}

export type Panel = DinamicDashboard | number;
